import { render } from "./MainDGII.vue?vue&type=template&id=ec2296d4&scoped=true"
import script from "./MainDGII.vue?vue&type=script&lang=js"
export * from "./MainDGII.vue?vue&type=script&lang=js"

import "./MainDGII.vue?vue&type=style&index=0&id=ec2296d4&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2296d4"]])

export default __exports__